import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  DragAndDropFileUpload,
  InputPassword,
} from "@altimateai/lego";
import { Control, UseFormReturn } from "react-hook-form";
import { SnowflakeFormValues } from "../SnowflakeConnection";

const ACCEPTED_FILE_EXTENSIONS = [".pem", ".der", ".p8", ".key"];

interface KeyPairAuthFieldsProps {
  control: Control<SnowflakeFormValues>;
  form: UseFormReturn<SnowflakeFormValues>;
}

export const KeyPairAuthFields = ({ control, form }: KeyPairAuthFieldsProps) => {
  return (
    <div title="key-file-control">
      <FormField
        control={control}
        name="key_pair.private_key"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Key File</FormLabel>
            <FormControl>
              <DragAndDropFileUpload
                maxFiles={1}
                acceptedFileTypes={ACCEPTED_FILE_EXTENSIONS}
                onFilesSelected={files => {
                  const file = files[0];
                  if (!file) {
                    field.onChange("");
                    field.onBlur();
                    return;
                  }

                  // Read file and base64 encode
                  const reader = new FileReader();
                  reader.onload = function (event) {
                    const fileContent = event?.target?.result as string;
                    if (fileContent) {
                      // Convert to base64 (remove data:mime/type;base64, prefix if present)
                      const base64Content = fileContent.includes(",")
                        ? fileContent.split(",")[1]
                        : btoa(fileContent);
                      field.onChange(base64Content);
                      field.onBlur();
                      form.clearErrors("key_pair.private_key");
                    }
                  };
                  reader.onerror = function () {
                    form.setError("key_pair.private_key", {
                      type: "manual",
                      message: "Failed to read file.",
                    });
                    field.onBlur();
                  };
                  reader.readAsDataURL(file);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="key_pair.passphrase"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="passphrase">Passphrase</FormLabel>
            <FormControl>
              <InputPassword
                id="passphrase"
                placeholder={
                  "Passphrase used for encrypting private key. If not encrypted, leave blank."
                }
                {...field}
                className="al-mt-1"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
